export default __webpack_public_path__ + "static/media/mazapan.67cb401f.jpg";